import { Data } from 'signup-constants/signupData/Data';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { executeCallbackIfEmailSubmitted } from '../flow-management/checkForEmailUtils';
import { shouldRetryCompanyInfo } from '../http-company-info/shouldRetryCompanyInfo';
import { EndpointKey } from '../http/EndpointKey';
import { AppActionTypes } from '../store/app/action-types';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { FlowActionTypes } from '../store/flow/action-types';
import { isDeveloperFlow } from '../store/flow/selectors';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { setSignupDataValue } from '../store/signup-data/action-creators';
import { prefillCompanyDomainFromEmail } from './prefillCompanyDomainFromEmail';
import { prefillHubInterest } from './prefillHubInterest';
import { prefillEmbeddedSignupData, prefillQueryParamSignupData } from './prefillSignupData';
import { shouldPrefillHubletAutomatically } from '../hublets/hubletUtils';
export const PrefillingMiddleware = store => next => action => {
  const dispatchResult = next(action);
  const state = store.getState();
  const isACQ0155Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0155, [ExperimentParameterGroup.Variant_A]);
  if (action.type === AppActionTypes.AppStarted) {
    store.dispatch(prefillQueryParamSignupData());
  }
  if (action.type === AppActionTypes.EmbeddedPrefill) {
    store.dispatch(prefillEmbeddedSignupData(action.data));
  }
  if (action.type === FlowActionTypes.Load) {
    store.dispatch(prefillHubInterest());
    if (isACQ0155Variant || shouldPrefillHubletAutomatically()) {
      store.dispatch(setSignupDataValue(Data.HubletSelection, HubletOption.na1));
    }
  }
  if (isDeveloperFlow()) {
    executeCallbackIfEmailSubmitted(store.getState(), action, email => {
      store.dispatch(prefillCompanyDomainFromEmail(email));
    });
  }
  if (shouldRetryCompanyInfo(state, action)) {
    store.dispatch(retryEndpoint(EndpointKey.CompanyInfo));
  }
  return dispatchResult;
};